import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar.js'
import Home from './pages/Home.js'
import MapPage from './pages/MapPage.js';
import Archive from './pages/Archive.js';
import ProjectsPage from './pages/ProjectsPage.js';
import ListPage from './pages/ListPage.js';
import AboutPage from './pages/AboutPage.js';
import ItemPage from './pages/details/ItemPage.js';
import ProjectPage from './pages/details/ProjectPage.js';
import CollectionsPage from './pages/details/CollectionsPage.js';
import MediaPage from './pages/details/MediaPage.js';
import TownPage from './pages/details/TownPage.js';
import CityPage from './pages/details/CityPage.js';
import CountryPage from './pages/details/CountryPage.js';
import CategoryPage from './pages/details/CategoryPage.js';
import SubcategoryPage from './pages/details/SubcategoryPage.js';
import KeywordPage from './pages/details/KeywordPage.js';
import PeoplePage from './pages/details/PeoplePage.js';
import NotFoundPage from './pages/NotFoundPage.js';

{/*   
import AddPage from './pages/AddPage.js';
import ManagePerson from './pages/manage/ManagePerson.js';
import ManageProject from './pages/manage/ManageProject.js';
import EditPage from './pages/EditPage.js';
*/}


function App() {
  return (
    <Router>
       <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/archive" element={<Archive />} />
        <Route path="/map" element={<MapPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/list" element={<ListPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/item/:itemid" element={<ItemPage />} />
        <Route path="/project/:prjid" element={<ProjectPage />} />
        <Route path="/collection/:colid" element={<CollectionsPage />} />
        <Route path="/media/:medid" element={<MediaPage />} />
        <Route path="/place/town/:plcid" element={<TownPage />} />
        <Route path="/place/city/:plcid" element={<CityPage />} />
        <Route path="/place/country/:plcid" element={<CountryPage />} />
        <Route path="/category/:catid" element={<CategoryPage />} />
        <Route path="/subcategory/:subcatid" element={<SubcategoryPage />} />
        <Route path="/keyword/:keywordid" element={<KeywordPage />} />
        <Route path="/people/:persid" element={<PeoplePage />} />
        <Route path="*" element={<NotFoundPage />} />
         {/*    
        <Route path="/add" element={<AddPage />} />
        <Route path="/manage/person" element={<ManagePerson />} />
        <Route path="/manage/project" element={<ManageProject />} />
        <Route path="/edit/:itemid" element={<EditPage />} />
         */}
      </Routes>
    </Router>
  );
}

export default App;
